import React from 'react';

/** IP Intel Report — a report page under a magnifier. Same stroke weight and
 *  active tan as the Ocean / Cosmos nav icons. */
export const IpIntelIcon = ({ active }: { active: boolean }) => {
  const c = active ? '#9A7A4C' : 'currentColor';
  return (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M14.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.5" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 3L19 7.5V10" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5 3v4.5H19" stroke={c} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" opacity="0.75" />
      <path d="M8.5 11h5M8.5 14.5h2.5" stroke={c} strokeWidth="1.6" strokeLinecap="round" opacity="0.75" />
      <circle cx="16.5" cy="16.5" r="3" stroke={c} strokeWidth="1.6" />
      <path d="M18.7 18.7L21 21" stroke={c} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
};
